import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormSectionHeader from '../common/FormSectionHeader';
import { getFieldError } from './utils';
import { TextFieldWithLabel } from '../components/TextField';
import { MAX_LENGTH_CONSTRAINTS } from '../constants';

const styles = (theme) => ({
  container: {
    display: 'flex',
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: '4px',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    padding: 8
  },
  commentsWrapper: {
    flexGrow: 1
  },
  commentsLabel: {
    minWidth: 90,
    alignSelf: 'flex-start',
    marginTop: 24
  }
});

const UnvoidPickupForm = ({ classes, unvoidPickupData, updateUnvoidPickup }) => {
  const handleChange = (value) => {
    updateUnvoidPickup({
      ...unvoidPickupData,
      comment: value,
      errorInfo: {
        ...unvoidPickupData.errorInfo,
        comment: getFieldError('comment', value)
      },
      commentCount: value.length
    });
  };

  const MAX_COMMENT_LENGTH = MAX_LENGTH_CONSTRAINTS.VOID_PICKUP_FORM.COMMENT;
  return (
    <>
      <FormSectionHeader label="Unvoid Reason Info" />
      <div className={classes.container} id="unvoidPickup">
        <div className={classes.commentsWrapper}>
          <TextFieldWithLabel
            label="Comments :"
            id="comment"
            labelClass={classes.commentsLabel}
            handleChange={handleChange}
            error={unvoidPickupData.errorInfo.comment}
            inputClass={classes.comments}
            multiline
            rows={3}
            inputProps={{
              maxLength: MAX_COMMENT_LENGTH
            }}
            helperText={`${unvoidPickupData.commentCount ?? 0}/${MAX_COMMENT_LENGTH}`}
          />
        </div>
      </div>
    </>
  );
};

export default withStyles(styles)(UnvoidPickupForm);
